import React, { useState } from 'react';
import { Search, Filter, CheckCircle, XCircle, AlertTriangle, Eye, FileText, Download } from 'lucide-react';
export const VerificationManagement = () => {
  const [selectedSub, setSelectedSub] = useState<number | null>(1);
  const [activeDoc, setActiveDoc] = useState<'cofo' | 'govid'>('cofo');
  const submissions = [{
    id: 1,
    property: 'Luxury 5-Bed Duplex',
    seller: 'Premium Homes Ltd',
    district: 'Maitama',
    date: 'Oct 24, 2023',
    status: 'pending'
  }, {
    id: 2,
    property: 'Commercial Plot',
    seller: 'John Doe',
    district: 'Central Area',
    date: 'Oct 23, 2023',
    status: 'pending'
  }, {
    id: 3,
    property: '3-Bed Apartment',
    seller: 'Jane Smith',
    district: 'Gwarinpa',
    date: 'Oct 23, 2023',
    status: 'pending'
  }];
  return <div className="h-[calc(100vh-8rem)] flex flex-col animate-in fade-in" data-id="element-944">
      <div className="mb-6 flex items-center justify-between" data-id="element-945">
        <div data-id="element-946">
          <h1 className="text-2xl font-serif font-bold text-slate-900 dark:text-white mb-1" data-id="element-947">
            Verification Queue
          </h1>
          <p className="text-slate-500 dark:text-slate-400" data-id="element-948">
            Review and approve property listings.
          </p>
        </div>
      </div>

      <div className="flex-grow flex gap-6 overflow-hidden" data-id="element-949">
        {/* Left Panel: Queue */}
        <div className="w-1/3 bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 flex flex-col overflow-hidden shrink-0 transition-colors duration-200" data-id="element-950">
          <div className="p-4 border-b border-slate-200 dark:border-slate-700" data-id="element-951">
            <div className="relative" data-id="element-952">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500" size={18} data-id="element-953" />
              <input type="text" placeholder="Search submissions..." className="w-full pl-10 pr-4 py-2 rounded-lg bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-600 text-slate-900 dark:text-white text-sm focus:ring-2 focus:ring-secondary outline-none transition-colors duration-200" data-id="element-954" />
            </div>
          </div>

          <div className="flex-grow overflow-y-auto custom-scrollbar p-2 space-y-2" data-id="element-955">
            {submissions.map(sub => <div key={sub.id} onClick={() => setSelectedSub(sub.id)} className={`p-4 rounded-xl cursor-pointer transition-colors border ${selectedSub === sub.id ? 'bg-secondary/10 border-secondary/30' : 'bg-slate-50 dark:bg-slate-800/50 border-transparent hover:bg-slate-100 dark:hover:bg-slate-800'}`} data-id="element-956">
                <div className="flex justify-between items-start mb-2" data-id="element-957">
                  <h3 className={`font-bold text-sm ${selectedSub === sub.id ? 'text-secondary' : 'text-slate-900 dark:text-slate-200'}`} data-id="element-958">
                    {sub.property}
                  </h3>
                  <span className="text-[10px] font-bold px-2 py-0.5 rounded bg-yellow-50 dark:bg-yellow-500/10 text-yellow-600 dark:text-yellow-500 uppercase" data-id="element-959">
                    Pending
                  </span>
                </div>
                <div className="text-xs text-slate-500 dark:text-slate-400 mb-1" data-id="element-960">
                  {sub.seller}
                </div>
                <div className="flex justify-between items-center text-[10px] text-slate-400 dark:text-slate-500" data-id="element-961">
                  <span data-id="element-962">{sub.district}</span>
                  <span data-id="element-963">{sub.date}</span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Right Panel: Details */}
        {selectedSub ? <div className="flex-grow bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 flex flex-col overflow-hidden transition-colors duration-200" data-id="element-964">
            {/* Header Info */}
            <div className="p-6 border-b border-slate-200 dark:border-slate-700 flex justify-between items-start bg-slate-50 dark:bg-slate-800/30" data-id="element-965">
              <div data-id="element-966">
                <div className="flex items-center gap-3 mb-2" data-id="element-967">
                  <h2 className="text-xl font-bold text-slate-900 dark:text-white" data-id="element-968">
                    Luxury 5-Bed Duplex
                  </h2>
                  <span className="px-2 py-1 bg-slate-200 dark:bg-slate-700 text-slate-700 dark:text-slate-300 text-xs font-bold rounded" data-id="element-969">
                    ID: #SUB-8492
                  </span>
                </div>
                <div className="flex gap-6 text-sm text-slate-500 dark:text-slate-400" data-id="element-970">
                  <span data-id="element-971">
                    Seller:{' '}
                    <strong className="text-slate-900 dark:text-slate-200" data-id="element-972">
                      Premium Homes Ltd
                    </strong>
                  </span>
                  <span data-id="element-973">
                    District:{' '}
                    <strong className="text-slate-900 dark:text-slate-200" data-id="element-974">
                      Maitama (Tier 1)
                    </strong>
                  </span>
                  <span data-id="element-975">
                    Submitted:{' '}
                    <strong className="text-slate-900 dark:text-slate-200" data-id="element-976">
                      Oct 24, 2023
                    </strong>
                  </span>
                </div>
              </div>

              <div className="flex gap-2" data-id="element-977">
                <button className="px-4 py-2 bg-emerald-50 dark:bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 hover:bg-emerald-100 dark:hover:bg-emerald-500/20 border border-emerald-200 dark:border-emerald-500/20 rounded-lg text-sm font-bold flex items-center gap-2 transition-colors" data-id="element-978">
                  <CheckCircle size={16} data-id="element-979" /> Approve
                </button>
                <button className="px-4 py-2 bg-red-50 dark:bg-red-500/10 text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-500/20 border border-red-200 dark:border-red-500/20 rounded-lg text-sm font-bold flex items-center gap-2 transition-colors" data-id="element-980">
                  <XCircle size={16} data-id="element-981" /> Reject
                </button>
              </div>
            </div>

            {/* Content Split */}
            <div className="flex-grow flex overflow-hidden" data-id="element-982">
              {/* Document Viewer */}
              <div className="w-2/3 border-r border-slate-200 dark:border-slate-700 flex flex-col bg-slate-100 dark:bg-slate-900/50" data-id="element-983">
                <div className="p-3 border-b border-slate-200 dark:border-slate-700 flex justify-between items-center bg-white dark:bg-[#1e293b]" data-id="element-984">
                  <div className="flex gap-2" data-id="element-985">
                    <button onClick={() => setActiveDoc('cofo')} className={`px-3 py-1.5 text-xs font-bold rounded ${activeDoc === 'cofo' ? 'bg-slate-200 dark:bg-slate-700 text-slate-900 dark:text-white' : 'bg-transparent text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'}`} data-id="element-986">
                      C of O
                    </button>
                    <button onClick={() => setActiveDoc('govid')} className={`px-3 py-1.5 text-xs font-bold rounded ${activeDoc === 'govid' ? 'bg-slate-200 dark:bg-slate-700 text-slate-900 dark:text-white' : 'bg-transparent text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'}`} data-id="element-987">
                      Gov ID
                    </button>
                  </div>
                  <button className="text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white" data-id="element-988">
                    <Download size={16} data-id="element-989" />
                  </button>
                </div>
                <div className="flex-grow p-6 flex items-center justify-center" data-id="element-990">
                  {/* Placeholder for PDF Viewer */}
                  <div className="w-full max-w-lg aspect-[1/1.4] bg-white rounded shadow-2xl flex flex-col items-center justify-center text-slate-400 p-8 text-center" data-id="element-991">
                    <FileText size={48} className="mb-4 text-slate-300" data-id="element-992" />
                    <p className="font-medium text-slate-600 mb-2" data-id="element-993">
                      {activeDoc === 'cofo' ? 'Certificate of Occupancy.pdf' : 'Government ID.pdf'}
                    </p>
                    <p className="text-xs text-slate-400" data-id="element-994">
                      Document preview would render here.
                    </p>
                  </div>
                </div>
              </div>

              {/* Verification Checklist */}
              <div className="w-1/3 p-6 overflow-y-auto custom-scrollbar" data-id="element-995">
                <h3 className="font-bold text-slate-900 dark:text-white mb-4" data-id="element-996">
                  Verification Checklist
                </h3>

                <div className="space-y-4 mb-8" data-id="element-997">
                  {['Document is legible and clear', 'Name matches seller profile', 'AGIS/FCDA file number is valid', 'No signs of tampering/forgery', 'Property dimensions match listing'].map((item, i) => <label key={i} className="flex items-start gap-3 cursor-pointer group" data-id="element-998">
                      <input type="checkbox" className="mt-1 rounded border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-secondary focus:ring-secondary focus:ring-offset-white dark:focus:ring-offset-slate-900" data-id="element-999" />
                      <span className="text-sm text-slate-700 dark:text-slate-300 group-hover:text-slate-900 dark:group-hover:text-white transition-colors" data-id="element-1000">
                        {item}
                      </span>
                    </label>)}
                </div>

                <div className="space-y-4" data-id="element-1001">
                  <h3 className="font-bold text-slate-900 dark:text-white" data-id="element-1002">
                    Admin Notes
                  </h3>
                  <textarea rows={4} placeholder="Add internal notes or rejection reason..." className="w-full p-3 rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-600 text-slate-900 dark:text-white text-sm focus:ring-2 focus:ring-secondary outline-none resize-none" data-id="element-1003"></textarea>

                  <button className="w-full py-2 bg-slate-50 dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 border border-slate-200 dark:border-slate-600 rounded-lg text-sm font-bold flex items-center justify-center gap-2 transition-colors" data-id="element-1004">
                    <AlertTriangle size={16} className="text-yellow-600 dark:text-yellow-500" data-id="element-1005" />{' '}
                    Flag for Review
                  </button>
                </div>
              </div>
            </div>
          </div> : <div className="flex-grow bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 flex items-center justify-center text-slate-500 transition-colors duration-200" data-id="element-1006">
            Select a submission to review
          </div>}
      </div>
    </div>;
};